import styled from 'styled-components'

import { white } from 'styles/colors'
import { H1 } from 'styles/typography'
import { media } from 'styles/media'

export default styled(H1)`
  color: ${white};
  font-family: 'Trim Poster';

  ${media.xLarge`
    font-size: 3.5rem; /* 56px */
  `};

  em {
    position: relative;
    color: transparent; /* Match page bg color */
    font-style: normal;
    -webkit-text-stroke: 1px ${white};

    &:after,
    &:before {
      position: absolute;
      top: 4%;
      left: 0;
      right: 0;
      content: attr(data-text);
      filter: blur(3px);
      white-space: nowrap; /* Force onto 1 line */
    }
  }
`
